type DiscoveryFilter =
  | { kind: "for-you" }
  | { kind: "saved" }
  | { kind: "recently-read" }
  | { kind: "room"; roomId: string }
  | { kind: "topic"; topicUid: string };

const FILTER_PARAM = "filter";

function parseDiscoveryFilter(search: string): DiscoveryFilter {
  const params = new URLSearchParams(search);

  const legacy = params.get("room");
  if (legacy !== null && legacy.length > 0) {
    return { kind: "room", roomId: legacy };
  }
  // The mobile bar's own encoding, so a mobile link opens the same topic.
  const topic = params.get("topic");
  if (topic !== null && topic.length > 0) {
    return { kind: "topic", topicUid: topic };
  }

  const raw = params.get(FILTER_PARAM);
  if (raw === null || raw === "for-you") return { kind: "for-you" };
  if (raw === "saved") return { kind: "saved" };
  if (raw === "recently-read") return { kind: "recently-read" };

  if (raw.startsWith("room:")) {
    const roomId = raw.slice("room:".length);
    if (roomId.length > 0) return { kind: "room", roomId };
  }
  if (raw.startsWith("topic:")) {
    const topicUid = raw.slice("topic:".length);
    if (topicUid.length > 0) return { kind: "topic", topicUid };
  }

  return { kind: "for-you" };
}

function buildDiscoverySearch(filter: DiscoveryFilter): string {
  switch (filter.kind) {
    case "for-you":
      return "";
    case "saved": {
      const p = new URLSearchParams();
      p.set(FILTER_PARAM, "saved");
      return `?${p.toString()}`;
    }
    case "recently-read": {
      const p = new URLSearchParams();
      p.set(FILTER_PARAM, "recently-read");
      return `?${p.toString()}`;
    }
    case "room": {
      const p = new URLSearchParams();
      p.set(FILTER_PARAM, `room:${filter.roomId}`);
      return `?${p.toString()}`;
    }
    case "topic": {
      const p = new URLSearchParams();
      p.set(FILTER_PARAM, `topic:${filter.topicUid}`);
      return `?${p.toString()}`;
    }
    default:
      throw new Error(filter satisfies never);
  }
}

export { type DiscoveryFilter, parseDiscoveryFilter, buildDiscoverySearch };
